import { validateCPF } from 'validations-br';
import * as Yup from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';

const cellphoneLength = 11;

const requiredString = (name: string) => {
  const message = `${name} não pode ficar em branco`;
  return Yup.string().typeError(message).required(message);
};

const cpfValidation = requiredString('CPF').test(
  'is-cpf',
  'CPF inválido',
  (value: string | undefined) => validateCPF(value as string)
);

export const employeeValidation = () =>
  yupResolver(
    Yup.object().shape({
      name: requiredString('Nome Completo'),
      cpf: cpfValidation,
      email: requiredString('E-mail').email('E-mail inválido'),
      phone: Yup.string()
        .nullable()
        .test('cellphoneValidation', 'Número de celular inválido', (value) => {
          if (!value) {
            return true;
          }
          return value.length === cellphoneLength;
        }),
    })
  );

